<template>
	<div class="logo" @click="backHome">
		<img src="../../assets/common/logo.png">
		<div class="text">
			<p class="chinese">索道云</p>
			<!-- <p class="english">Ropeway Cloud</p> -->
            <img src="../../assets/common/logo_text.jpg" alt="">
		</div>
	</div>
</template>

<script>
    export default {
        methods: {
            backHome() {
                this.$router.push({
                    path: '/'
                })
            }
        },
    }
</script>

<style lang="scss">
    .logo {
        display: flex;
        img {
            width: 55px;
            height: 50px;
        }
        .text {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 48px;
            margin: 2px 0 0 5px;
            min-width: 110px;
            p {
                padding: 0;
                margin: 0;
            }
            .chinese {
                height: 32px;
                font-size: 20px;
                font-weight: 900;
                font-family: Arial;
                letter-spacing: 5px;
                line-height: 32px;
            }
            // .english {
            //     font-size: 8px;
            //     font-weight: 900;
            //     font-family: Arial;
            // }
            img {
                width: 70px;
                height: 12px;
            }
        }
    }
    
    .logo:hover {
        cursor: pointer;
    }
</style>